import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BackLink from "../../HelperComponents/BackLink/BackLink";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import SearchIcon from "../../../assets/image/search_grey.png";
import DialogComponent from "../../HelperComponents/DialogComponent/DialogComponent";
import TransitionedBlock from "../../HelperComponents/TransitionedBlock/TransitionedBlock";
import PrintComponents from "react-print-components";
import PopperInfo from "../../HelperComponents/PopperInfo/PopperInfo";
import NoItems from "../../HelperComponents/NoItems/NoItems";
import EmptyIcon from "../../../assets/image/no_prices.png";
import LogoBlue from "../../../assets/image/logo_blue.png";
import MinusIcon from "../../../assets/image/minus.png";
import PlusIcon from "../../../assets/image/plus.png";
import delete_items from "../../../assets/image/delete_items.png";
import ScanSound from "./assets/scan_sound.mp3";
import ScanSoundError from "./assets/scan_error_sound.mp3";

import TwoTableLayout from "../../HelperComponents/TwoTableLayout/TwoTableLayout";

import moment from "moment/moment";

import {
  searchCompanies,
  getCompaniesGoods,
  postNewResidue,
} from "../../../actions/disposalBalancesActions";
import { isArray } from "../../../helpers/functions";

import IconButton from "@material-ui/core/IconButton";
import CloseDialogIcon from "../../../assets/image/Mask.png";
import { SuccessMessage } from "../../HelperComponents/ToastMessages/ToastMessage";

import "./NewIssue.scss";

class NewIssue extends Component {
  state = {
    open: false,
    openPopper: false,
    anchorEl: null,
    value: "",
    articleNumber: "",
    idCompany: null,
    printed: false,
    loading: false,
    now: new Date().toISOString(),
    error: null,
    cartOrders: [],
    cartDisplay: [],
    initialGoods: [],
    articleOptions: [],
    openEditDialog: false,
    editingCartItem: null,
    openNoItemDialog: false,
    openAlreadyAddedDialog: false,
    anchorElArticle: null,
    openArticlePopper: false,
    openDeleteDialog: false,
    orderToDelete: null,
    successToast: false,
  };

  debounceTimer = null;
  scanAudio = new Audio(ScanSound);
  scanErrorAudio = new Audio(ScanSoundError);

  componentDidMount = () => {
    const { searchCompanies } = this.props;
    this.setState({ 
      anchorEl: document.getElementById("products")
    });
    searchCompanies();
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { disposal_balances } = this.props;
    const { disposal_balances: prevDisposalBalances } = prevProps;
    const { initialGoods, idCompany, anchorElArticle, cartOrders, printed } = this.state;

    if (
      disposal_balances.error &&
      disposal_balances.error !== prevDisposalBalances.error
    ) {
      this.setState({ error: disposal_balances.error });
    }

    if (
      disposal_balances.goods &&
      disposal_balances.goods.orders &&
      disposal_balances.goods.orders.length > 0 &&
      disposal_balances.goods.orders !== prevDisposalBalances.goods.orders &&
      initialGoods.length === 0
    ) {
      this.setState({ initialGoods: disposal_balances.goods.orders });
    }

    if (idCompany && !anchorElArticle) {
      const articleElement = document.getElementById("article_input");
      if (articleElement) {
        this.setState({ anchorElArticle: articleElement });
      }
    }

    if (cartOrders !== prevState.cartOrders && printed) {
      this.setState({ printed: false });
    }
  };

  componentWillUnmount = () => {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  };

  doRequest = (id, articleNum = "") => {
    const { getCompaniesGoods } = this.props;
    this.setState({ error: null });
    getCompaniesGoods(id, articleNum).then((res) => {
      if (res.payload && res.payload.data && res.payload.data.orders) {
        this.setState({ articleOptions: res.payload.data.orders });
      }
    });
  };

  doInitialRequest = (id) => {
    const { getCompaniesGoods } = this.props;
    this.setState({ error: null });
    getCompaniesGoods(id);
  };

  toggleDialog = () => {
    const { printed } = this.state;
    if (printed) {
      this.handlePost();
    } else {
      this.setState(({ open }) => ({
        open: !open,
      }));
    }
  };

  cancelDialog = () => {
    this.setState({
      open: false,
      printed: false,
    });
  };

  onChange = (e) => {
    const value = e.target.value;
    this.setState({ value });
  };

  clearArticleField = () => {
    this.setState({ articleNumber: "", articleOptions: [] });
  };

  onKeyUp = (e) => {
    const value = e.target.value;
    if (value.length > 0 && value.indexOf(" ") === -1) {
      this.setState({
        openPopper: true,
        idCompany: null,
      });
    } else {
      this.setState({
        openPopper: false,
        idCompany: null,
      });
    }
  };

  clickAway = () => {
    this.setState(({ openPopper }) => ({
      openPopper: !openPopper,
    }));
  };

  selectProduct = (e) => {
    this.setState({ 
      value: e.company, 
      idCompany: e.id, 
      openPopper: false,
      cartOrders: [],
      cartDisplay: [],
      articleNumber: "",
      initialGoods: [],
      articleOptions: []
    });
    this.doInitialRequest(e.id);
  };

  onArticleChange = (e) => {
    const articleNumber = e.target.value;
    this.setState({ articleNumber });
  };

  onArticleKeyUp = (e) => {
    const { idCompany, articleNumber } = this.state;

    if (e.keyCode === 13 && articleNumber.length > 0) {
      this.searchArticle();
      return;
    }

    if (articleNumber.length > 0) {
      this.setState({ openArticlePopper: true });
    } else {
      this.setState({ openArticlePopper: false });
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    if (idCompany && articleNumber.length > 0) {
      this.debounceTimer = setTimeout(() => {
        this.doRequest(idCompany, articleNumber);
      }, 500);
    } else if (articleNumber.length === 0) {
      this.setState({ articleOptions: [] });
    }
  };

  clickAwayArticle = () => {
    this.setState({ openArticlePopper: false });
  };

  selectArticle = (article) => {
    this.setState({ articleNumber: article, openArticlePopper: false });
    setTimeout(() => {
      this.searchArticle();
    }, 0);
  };

  searchArticle = () => {
    const { articleNumber, initialGoods, cartOrders, cartDisplay } = this.state;

    const matchedOrders = initialGoods.filter(
      (item) => item.article_number.toLowerCase() === articleNumber.toLowerCase()
    );

    if (matchedOrders.length === 0) {
      this.setState({ openNoItemDialog: true });

      this.scanErrorAudio.play().catch(err => console.error('Audio play error:', err));

      return;
    }

    const order = matchedOrders.find(order => {
      const alreadyInCart = this.getCartItemAmount(order.id);
      const availableAmount = order.in_stock - alreadyInCart;

      return availableAmount > 0;
    })
    

    if (!order) {
      this.setState({
        openAlreadyAddedDialog: true,
        articleNumber: "",
        articleOptions: []
      });

      this.scanErrorAudio.play().catch(err => console.error('Audio play error:', err));

      return;
    }

    const existingCartItem = cartOrders.find(c => c.id === order.id);
    const updatedCartOrders = [...cartOrders];

    if (existingCartItem) {
      existingCartItem.selectedAmount += 1;
    } else {
      updatedCartOrders.push({ ...order, selectedAmount: 1 });
    }

    let updatedCartDisplay = [...cartDisplay];
    const lastItemIndex = updatedCartDisplay.length - 1;
    if (updatedCartDisplay.length > 0 && 
        updatedCartDisplay[lastItemIndex].article_number.toLowerCase() === order.article_number.toLowerCase() &&
        updatedCartDisplay[lastItemIndex].id === order.id) {
      updatedCartDisplay[lastItemIndex].selectedAmount += 1;
    } else {
      updatedCartDisplay.push({ ...order, selectedAmount: 1 });
    }

    this.scanAudio.play().catch(err => console.error('Audio play error:', err));

    this.setState({
      cartOrders: updatedCartOrders,
      cartDisplay: updatedCartDisplay,
      articleNumber: "",
      articleOptions: [],
      successToast: true
    });

    return;
  };

  openEditCartItemDialog = (cartItem) => {
    const { cartDisplay, cartOrders } = this.state;
    const originalItem = this.state.initialGoods.find(g => g.id === cartItem.id);
    const maxAmount = originalItem ? originalItem.in_stock : cartItem.selectedAmount;
    
    const itemIndex = cartDisplay.findIndex(item => item === cartItem);
    
    const totalInCartOrders = cartOrders
      .filter(item => item.id === cartItem.id)
      .reduce((sum, item) => sum + item.selectedAmount, 0);
    
    const currentRowAmount = cartItem.selectedAmount;
    const availableAmount = maxAmount - (totalInCartOrders - currentRowAmount);

    this.setState({
      editingCartItem: {
        ...cartItem,
        available_amount: availableAmount,
        tempAmount: cartItem.selectedAmount,
        _editIndex: itemIndex
      },
      openEditDialog: true
    });
  };

  toggleEditDialog = () => {
    this.setState(prevState => ({
      openEditDialog: !prevState.openEditDialog,
      editingCartItem: null
    }));
  };

  toggleNoItemDialog = () => {
    this.setState(prevState => ({
      openNoItemDialog: !prevState.openNoItemDialog
    }));
  };

  toggleAlreadyAddedDialog = () => {
    this.setState(prevState => ({
      openAlreadyAddedDialog: !prevState.openAlreadyAddedDialog
    }));
  };

  changeEditAmount = (type) => {
    const { editingCartItem } = this.state;
    if (!editingCartItem) return;

    const maxAllowed = editingCartItem.available_amount !== undefined 
      ? editingCartItem.available_amount 
      : editingCartItem.tempAmount;

    if (type === 'plus') {
      if (editingCartItem.tempAmount >= maxAllowed) return;
      editingCartItem.tempAmount++;
    } else {
      if (editingCartItem.tempAmount <= 1) return;
      editingCartItem.tempAmount--;
    }
    this.setState({ editingCartItem });
  };

  getCartItemAmount = (orderId) => {
    const { cartOrders } = this.state;
    const cartItem = cartOrders.find(c => c.id === orderId);
    return cartItem ? cartItem.selectedAmount : 0;
  };

  checkEditAmountHandler = (e) => {
    const { editingCartItem } = this.state;
    if (!editingCartItem) return;

    const maxAllowed = editingCartItem.available_amount !== undefined 
      ? editingCartItem.available_amount 
      : editingCartItem.tempAmount;
    let value = Number(e.target.value);
    if (e.target.value === '' || value < 1) {
      editingCartItem.tempAmount = 1;
    } else if (value > maxAllowed) {
      editingCartItem.tempAmount = maxAllowed;
    }
    this.setState({ editingCartItem });
  };

  handleEditConfirm = () => {
    const { editingCartItem, cartOrders, cartDisplay } = this.state;
    if (!editingCartItem) return;

    const oldAmount = editingCartItem.selectedAmount;
    const newAmount = editingCartItem.tempAmount;
    const difference = newAmount - oldAmount;

    const existingCartOrder = cartOrders.find(item => item.id === editingCartItem.id);
    const updatedCartOrders = [...cartOrders];
    
    if (existingCartOrder) {
      existingCartOrder.selectedAmount += difference;
    } else {
      updatedCartOrders.push({ ...editingCartItem, selectedAmount: newAmount });
    }

    const updatedCartDisplay = cartDisplay.map((item, index) => {
      if (index === editingCartItem._editIndex) {
        return { ...item, selectedAmount: newAmount };
      }
      return item;
    });

    this.setState({
      cartOrders: updatedCartOrders,
      cartDisplay: updatedCartDisplay,
      openEditDialog: false,
      editingCartItem: null
    });
  };

  handleChangeTextarea = (e) => {
    this.setState({ comment: e.target.value });
  };

  handlePost = () => {
    const { postNewResidue, history } = this.props;
    const { comment, idCompany, cartOrders } = this.state;

    const scanned_orders = cartOrders.map((order) => ({
      order_id: order.id,
      quantity: order.selectedAmount,
    }));

    const data = {
      company_id: idCompany,
      comment: comment,
      scanned_orders: scanned_orders,
    };
    postNewResidue(data).then((res) => {
      if (res.payload) {
        this.setState({ loading: false });
        history.push("/admin/disposal-balances");
      }
    });
  };

  handlePrint = () => {
    this.setState({
      now: new Date().toISOString(),
      printed: true,
    });
  };

  handleDialogPrint = () => {
    const button = document.getElementById("print_button");
    button.click();
  };

  handleAddAllToCart = () => {
    const { initialGoods, cartOrders, cartDisplay } = this.state;
    if (initialGoods.length > 0) {
      const updatedCartOrders = [...cartOrders];
      const updatedCartDisplay = [...cartDisplay];
      
      initialGoods.forEach((order) => {
        const alreadyInCart = this.getCartItemAmount(order.id);
        const remainingAmount = order.in_stock - alreadyInCart;
        
        if (remainingAmount > 0) {
          const existingCartItem = updatedCartOrders.find(
            (cartOrder) => cartOrder.id === order.id
          );
          
          if (existingCartItem) {
            existingCartItem.selectedAmount += remainingAmount;
          } else {
            updatedCartOrders.push({ ...order, selectedAmount: remainingAmount });
          }

          updatedCartDisplay.push({ ...order, selectedAmount: remainingAmount });
        }
      });

      this.setState({ 
        cartOrders: updatedCartOrders,
        cartDisplay: updatedCartDisplay
      });
    }
  };

  deleteDialog = (order) => {
    const { cartDisplay } = this.state;
    const itemIndex = cartDisplay.findIndex(item => item === order);
    this.setState(prevState => ({
      openDeleteDialog: !prevState.openDeleteDialog,
      orderToDelete: { ...order, _deleteIndex: itemIndex },
    }));
  };

  deleteOrder = () => {
    const { orderToDelete } = this.state;
    if (!orderToDelete) return;

    this.setState(prevState => {
      const deletedAmount = orderToDelete.selectedAmount;
      
      const updatedCartDisplay = prevState.cartDisplay.filter(
        (item, index) => index !== orderToDelete._deleteIndex
      );

      const existingCartOrder = prevState.cartOrders.find(item => item.id === orderToDelete.id);
      const updatedCartOrders = [...prevState.cartOrders];
      
      if (existingCartOrder) {
        existingCartOrder.selectedAmount -= deletedAmount;
        if (existingCartOrder.selectedAmount <= 0) {
          const indexToRemove = updatedCartOrders.findIndex(item => item.id === orderToDelete.id);
          if (indexToRemove !== -1) {
            updatedCartOrders.splice(indexToRemove, 1);
          }
        }
      }

      return {
        cartOrders: updatedCartOrders,
        cartDisplay: updatedCartDisplay,
        openDeleteDialog: false,
        orderToDelete: null,
      };
    });
  };

  render() {
    const {
      disposal_balances: { companies },
    } = this.props;
    const {
      open,
      openPopper,
      anchorEl,
      value,
      articleNumber,
      idCompany,
      loading,
      now,
      error,
      cartOrders,
      cartDisplay,
      initialGoods,
      articleOptions,
      openEditDialog,
      editingCartItem,
      openNoItemDialog,
      openAlreadyAddedDialog,
      openArticlePopper,
      anchorElArticle,
      openDeleteDialog,
    } = this.state;
    let items = [];
    if (!!companies && companies.length > 0) {
      items = companies.filter((el) =>
        !!el.company && el.company !== null
          ? el.company.toLowerCase().includes(value.toLowerCase())
          : null
      );
    }

    return (
      <TransitionedBlock>
        <div className="new_issue container">
          <div className="flex-center-btw title-block-page">
            <div className="title-page">
              <BackLink />
              <h1>Новая выдача</h1>
            </div>
          </div>
          <div className="page_block">
            <div className="title">Поставщик</div>
            <div className="search_block">
              <input
                id="products"
                type="text"
                value={value}
                onChange={(e) => this.onChange(e)}
                onKeyUp={(e) => this.onKeyUp(e)}
                placeholder="Введите название или телефон компании"
                autoComplete="off"
              />
              <div className="search_buttons">
                <button className="search-btn">
                  <img src={SearchIcon} alt="SearchIcon" />
                </button>
              </div>
              <PopperInfo
                id="products_popper"
                open={openPopper}
                anchorEl={anchorEl}
                clickAway={this.clickAway}
                position="bottom-start"
                transition
              >
                <ul className="search_transactions_list">
                  {isArray(items) ? (
                    items.map((el, idEl) => (
                      <li
                        className="search_transactions_item"
                        onClick={() => this.selectProduct(el)}
                        key={idEl}
                      >
                        <div className="search_transactions_item_head">
                          {el.company}
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="search_transactions_no_items">
                      Компаний не найдено
                    </li>
                  )}
                </ul>
              </PopperInfo>
            </div>
            {idCompany && (
              <>
                <div className="title">Артикул</div>
                <div className="search_block">
                  <input
                    id="article_input"
                    type="text"
                    value={articleNumber}
                    onChange={(e) => this.onArticleChange(e)}
                    onKeyUp={(e) => this.onArticleKeyUp(e)}
                    placeholder="Введите артикул"
                    autoComplete="off"
                  />
                  <div className="search_buttons">
                    {articleNumber && (
                      <button
                        type="button"
                        className="clear-btn"
                        onClick={this.clearArticleField}
                        aria-label="Очистить поле"
                      >
                        ×
                      </button>
                    )}
                    <button className="search-btn" onClick={this.searchArticle}>
                      <img src={SearchIcon} alt="SearchIcon" />
                    </button>
                  </div>
                  <PopperInfo
                    id="article_popper"
                    open={openArticlePopper}
                    anchorEl={anchorElArticle}
                    clickAway={this.clickAwayArticle}
                    position="bottom-start"
                    transition
                  >
                    <ul className="search_transactions_list">
                      {articleOptions.length > 0 ? (
                        [...new Set(articleOptions.map(opt => opt.article_number))].map((article, idx) => (
                          <li
                            className="search_transactions_item"
                            onClick={() => this.selectArticle(article)}
                            key={idx}
                          >
                            <div className="search_transactions_item_head">
                              {article}
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="search_transactions_no_items">
                          Артикулов не найдено
                        </li>
                      )}
                    </ul>
                  </PopperInfo>
                </div>
              </>
            )}
            {error && <div className="error-message">{error}</div>}
            {initialGoods.length !== 0 ? (
              <Fragment>
                <div className="line_v" />
                <div className="goods_header">
                  <div className="goods_controls">
                    <DefaultButton
                      variant="outlined"
                      classes="waiting_for_documents"
                      onClick={this.handleAddAllToCart}
                    >
                      Добавить все
                    </DefaultButton>
                  </div>
                </div>
                <TwoTableLayout
                  leftTable={{
                    title: "Товары на складе",
                    columns: [
                      {
                        title: "Деталь",
                        style: { width: "40%" },
                        render: (item) =>
                          `${item.article_number} • ${item.producer}`,
                      },
                      {
                        title: "Наименование",
                        style: { width: "40%" },
                        render: (item) => item.name,
                      },
                      {
                        title: "К-во товара",
                        style: { width: "auto", margin: "0 auto" },
                        render: (item) => {
                          const cartItem = cartOrders.find(
                            (cart) => cart.id === item.id
                          );
                          return cartItem
                            ? item.in_stock - cartItem.selectedAmount
                            : item.in_stock;
                        },
                      },
                    ],
                    data: initialGoods.filter((good) => {
                      const cartItem = cartOrders.find(
                        (item) => item.id === good.id
                      );
                      if (!cartItem) return true;
                      return cartItem.selectedAmount < good.in_stock;
                    }),
                    emptyMessage: "Все товары добавлены.",
                    rowKey: "id",
                  }}
                  rightTable={{
                    title: "Выбрано к выдаче",
                    reverse: true,
                    columns: [
                      {
                        title: "Деталь",
                        style: { width: "35%" },
                        render: (item) =>
                          `${item.article_number} • ${item.producer}`,
                      },
                      {
                        title: "Наименование",
                        style: { width: "35%" },
                        render: (item) => item.name,
                      },
                      {
                        title: "К-во товара",
                        style: { width: "20%", textAlign: "center" },
                        render: (item) => item.selectedAmount,
                      },
                      {
                        title: "",
                        style: { width: "10%", textAlign: "center", cursor: "pointer" },
                        render: (item) => (
                          <button onClick={(e) => {
                            e.stopPropagation();
                            this.deleteDialog(item);
                          }}>
                            <img src={delete_items} alt="delete" />
                          </button>
                        ),
                      }
                    ],
                    data: cartDisplay,
                    emptyMessage: "Список выдачи пуст.",
                    keyExtractor: (item, idx) => `${item.id}_${idx}`,
                    onRowClick: (item) => this.openEditCartItemDialog(item),
                  }}
                />
              </Fragment>
            ) : !!idCompany ? (
              <NoItems>
                <div className="box-img">
                  <img src={EmptyIcon} alt="edit icon" />
                </div>
                <div className="title">Товаров на складе не найдено</div>
              </NoItems>
            ) : null}

            {cartOrders.length > 0 ? (
              <Fragment>
                <div className="line_v" />
                <div className="title">Комментарий</div>
                <textarea
                  className="info_new_issue"
                  placeholder="Ваше сообщение..."
                  onChange={(e) => this.handleChangeTextarea(e)}
                />
                <div className="btn_wrapper">
                  <div>
                    <DefaultButton onClick={this.toggleDialog}>
                      Выдать остаток
                    </DefaultButton>
                  </div>
                  <div onClick={this.handlePrint}>
                    <PrintComponents
                      trigger={
                        <button id="print_button" className="print_btn">
                          Печать
                        </button>
                      }
                    >
                      <div className="print_goods">
                        <div className="print_goods__header">
                          <div className="print_goods__header--logo">
                            <img src={LogoBlue} alt="Logo" />
                          </div>
                          <div className="print_goods__header--company">
                            {value}
                          </div>
                        </div>
                        <div className="print_goods__date">
                          <span>{moment(now).format("DD.MM.YYYY HH:mm")}</span>
                        </div>
                        <div className="new_issue_table">
                          <div className="table_container transactions_columns">
                            <div className="table_header">
                              <div className="table_row">
                                <div className="row_item">Название</div>
                                <div className="row_item">Артикул</div>
                                <div className="row_item">Производитель</div>
                                <div className="row_item">К-во товара</div>
                                <div className="row_item">Цена</div>
                                <div className="row_item">Сумма</div>
                              </div>
                            </div>
                            <div className="table_body">
                              {cartOrders.map((order, idx) => (
                                <div className="table_row" key={idx}>
                                  <div className="row_item">{order.name}</div>
                                  <div className="row_item">
                                    {order.article_number}
                                  </div>
                                  <div className="row_item">
                                    {order.producer}
                                  </div>
                                  <div className="row_item">
                                    {order.selectedAmount}
                                  </div>
                                  <div className="row_item">
                                    {order.price.toFixed(2)}
                                  </div>
                                  <div className="row_item">
                                    {(
                                      order.price * order.selectedAmount
                                    ).toFixed(2)}
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="table_container__summary">
                              Итого:{" "}
                              {cartOrders
                                .reduce(
                                  (sum, order) =>
                                    sum + order.price * order.selectedAmount,
                                  0
                                )
                                .toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </PrintComponents>
                  </div>
                </div>
              </Fragment>
            ) : null}
          </div>
          <DialogComponent open={open} onClose={this.cancelDialog}>
            <div className="title-dialog">Выдать остаток</div>
            <div className="descriptions_dialog_component">
              Вы уверены, что не хотите распечатать отчёт?
            </div>

            <div className="btn-wrapper order-dialog-btn more-dialog-btn">
              <div>
                <DefaultButton
                  variant="outlined"
                  classes="cancel_btn"
                  onClick={this.cancelDialog}
                >
                  Отмена
                </DefaultButton>
                <DefaultButton
                  onClick={() => {
                    this.setState({ loading: true });
                    this.handlePost();
                  }}
                  loading={loading}
                  disabled={loading}
                >
                  Выдать
                </DefaultButton>
              </div>
              <div>
                <button className="print_btn" onClick={this.handleDialogPrint}>
                  Печать
                </button>
              </div>
            </div>
            <IconButton
              classes={{
                root: "dialog_close_button",
              }}
              onClick={this.cancelDialog}
            >
              <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
          </DialogComponent>

          <DialogComponent
            open={openNoItemDialog}
            onClose={this.toggleNoItemDialog}
          >
            <div className="title-dialog">Совпадений не найдено</div>
            <div className="descriptions_dialog_component no_margin">
              Убедитесь в правильности поискового запроса и повторите попытку.
            </div>
            <div className="btn-wrapper order-dialog-btn">
              <DefaultButton onClick={this.toggleNoItemDialog}>Ок</DefaultButton>
            </div>
            <IconButton
              classes={{
                root: "dialog_close_button",
              }}
              onClick={this.toggleNoItemDialog}
            >
              <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
          </DialogComponent>

          <DialogComponent
            open={openAlreadyAddedDialog}
            onClose={this.toggleAlreadyAddedDialog}
          >
            <div className="title-dialog">Товар уже добавлен</div>
            <div className="descriptions_dialog_component no_margin">
              Все доступное количество данного товара уже добавлено в список выдачи.
            </div>
            <div className="btn-wrapper order-dialog-btn">
              <DefaultButton onClick={this.toggleAlreadyAddedDialog}>Ок</DefaultButton>
            </div>
            <IconButton
              classes={{
                root: "dialog_close_button",
              }}
              onClick={this.toggleAlreadyAddedDialog}
            >
              <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
          </DialogComponent>

          <DialogComponent
            open={openEditDialog}
            onClose={this.toggleEditDialog}
          >
            {editingCartItem && (
              <div>
                <div className="title-dialog">Редактировать количество</div>
                <div className="descriptions_dialog_component">
                  {editingCartItem.article_number} • {editingCartItem.producer}
                  <div style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
                    Добавлено: {editingCartItem.selectedAmount || 0} / {editingCartItem.available_amount || 0} шт.
                  </div>
                </div>
                <div className="amount" style={{ justifyContent: "center", marginTop: "20px" }}>
                  <button
                    style={{
                      opacity: editingCartItem.tempAmount <= 1 ? "0.3" : "1",
                      cursor: editingCartItem.tempAmount <= 1 ? "not-allowed" : "pointer",
                    }}
                    onClick={() => this.changeEditAmount("minus")}
                  >
                    <img src={MinusIcon} alt="-" />
                  </button>
                  <input
                    type="number"
                    min="1"
                    max={editingCartItem.available_amount !== undefined ? editingCartItem.available_amount : editingCartItem.tempAmount}
                    value={editingCartItem.tempAmount}
                    onChange={(e) => {
                      editingCartItem.tempAmount = Number(e.target.value);
                      this.setState({ editingCartItem });
                    }}
                    onBlur={(e) => this.checkEditAmountHandler(e)}
                  />
                  <button
                    style={{
                      opacity: editingCartItem.available_amount !== undefined && editingCartItem.tempAmount >= editingCartItem.available_amount ? "0.3" : "1",
                      cursor: editingCartItem.available_amount !== undefined && editingCartItem.tempAmount >= editingCartItem.available_amount ? "not-allowed" : "pointer",
                    }}
                    onClick={() => this.changeEditAmount("plus")}
                  >
                    <img src={PlusIcon} alt="+" />
                  </button>
                </div>
                <div className="btn-wrapper order-dialog-btn" style={{ marginTop: "30px" }}>
                  <DefaultButton
                    variant="outlined"
                    classes="cancel_btn"
                    onClick={this.toggleEditDialog}
                  >
                    Отмена
                  </DefaultButton>
                  <DefaultButton onClick={this.handleEditConfirm}>
                    Сохранить
                  </DefaultButton>
                </div>
                <IconButton
                  classes={{
                    root: "dialog_close_button",
                  }}
                  onClick={this.toggleEditDialog}
                >
                  <img src={CloseDialogIcon} alt="close icon" />
                </IconButton>
              </div>
            )}
          </DialogComponent>

          <DialogComponent
            open={openDeleteDialog}
            onClose={this.deleteDialog}
          >
            <div className="title-dialog">Удалить товар</div>
            <div className="descriptions_dialog_component no_margin">
              Вы уверены, что хотите удалить данный товар из списка?
            </div>
            <div className="btn-wrapper order-dialog-btn">
              <DefaultButton
                variant="outlined"
                classes="cancel_btn"
                onClick={this.deleteDialog}
              >
                Отмена
              </DefaultButton>
              <DefaultButton onClick={this.deleteOrder}>
                Удалить
              </DefaultButton>
            </div>
            <IconButton
              classes={{
                root: "dialog_close_button",
              }}
              onClick={this.deleteDialog}
            >
              <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
          </DialogComponent>

          {this.state.successToast && (
            <SuccessMessage
              close={() => this.setState({ successToast: false })}
              position="top"
              message="Товар добавлен"
              timeout={1500}
            />
          )}
        </div>
      </TransitionedBlock>
    );
  }
}

const mapStateToProps = ({ disposal_balances }) => ({
  disposal_balances,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchCompanies,
      getCompaniesGoods,
      postNewResidue,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NewIssue);
